import { ImageUploaderProps } from "@/components/common/Uploader/ImageUploader/ImageUploader";
import { extensionsConfig } from "@/config/extensionsConfig";

export const getToolName = (pathname: string) => pathname.split("/")[1];

export const getHtmlFileInputId = (pathname: string) => {
    const toolName = getToolName(pathname);
    return toolName ? `${toolName}-file-input` : `file-input`;
};

export const getSupportedExtensions = (pathname: string): ImageUploaderProps["supportedExtensions"] => {
    switch (getToolName(pathname)) {
        case "crop-jpg":
            return extensionsConfig["crop-jpg"];
        case "crop-png":
            return extensionsConfig["crop-png"];
        case "crop-webp":
            return extensionsConfig["crop-webp"];
        default:
            return extensionsConfig["crop"];
    }
};
